/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { SkillLink, SkillLink$inboundSchema } from "./skilllink.js";

/**
 * A page of live skill links for the current project.
 */
export type ListSkillLinksResult = {
  /**
   * The live skill links in this page.
   */
  links: Array<SkillLink>;
  /**
   * Cursor for the next page; absent when exhausted.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListSkillLinksResult$inboundSchema: z.ZodMiniType<
  ListSkillLinksResult,
  unknown
> = z.pipe(
  z.object({
    links: z.array(SkillLink$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listSkillLinksResultFromJSON(
  jsonString: string,
): SafeParseResult<ListSkillLinksResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSkillLinksResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSkillLinksResult' from JSON`,
  );
}
